/**
 * @file Homepage Stories
 */

import KeenSlider from 'keen-slider';

/**
 * Homepage Stories component
 */
const vHpStories = () => {
	const hpStories = document.querySelector('.v-hp-stories');

	if (!hpStories) {
		return;
	}

	const slider     = hpStories.querySelector('.v-hp-stories__slider');
	const controls   = hpStories.querySelector('.v-hp-stories__controls');
	// const dots       = hpStories.querySelectorAll('.v-hp-stories__dot');

	const keen = new KeenSlider(slider, {
		spacing:  64,
		loop:     true,
		controls: false,
		created:  (instance) => {
			if (controls) {
				const arrowLeft  = hpStories.querySelector('.v-hp-stories__btn--prev');
				const arrowRight = hpStories.querySelector('.v-hp-stories__btn--next');

				arrowLeft.addEventListener('click', () => {
					instance.prev();
				});

				arrowRight.addEventListener('click', () => {
					instance.next();
				});
			}

			/* [...dots].forEach((dot) => {
				const target = parseInt(dot.getAttribute('data-slide'), 10);
				dot.addEventListener('click', () => {
					instance.moveToSlide(target);
				});
			}); */
		},
		move: (instance) => {
			const slide    = instance.details().relativeSlide;
			const story    = hpStories.querySelector(`.v-hp-stories__slide[data-slide="${slide}"]`);
			const storyBtn = story.querySelector('.v-story__accordion-btn');

			if (storyBtn.getAttribute('aria-expanded') === 'true') {
				storyBtn.click();
			}
		},
		slideChanged: (instance) => {
			const slide     = instance.details().relativeSlide;
			const activeDot = hpStories.querySelector('.v-hp-stories__dot--active');
			const nextDot   = hpStories.querySelector(`.v-hp-stories__dot[data-slide="${slide}"]`);

			activeDot.classList.remove('v-hp-stories__dot--active');
			nextDot.classList.add('v-hp-stories__dot--active');
		},
	});
};

export default vHpStories;
